<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 个人信息->个人信息 -->
    <div class="main2" style="margin-top:-5px;">
      <el-table
        :data="userInfo"
        style="width: 100%;border-left:1px solid #e7e6e4"
        :cell-style="{
          'text-align': 'center',
          'border-color': '#dbdbdb',
          position: 'relative',
          'background-color': '#fff',
          'border-right': '1px solid #e7e6e4',
        }"
        :header-cell-style="{
          'background-color': '#b6b6b6',
          color: '#000',
          fontSize: '14px',
          fontWeight: '300',
          'text-align': 'center',
        }"
      >
        <el-table-column prop="customerName" label="用户名" width="100">
        </el-table-column>
        <el-table-column prop="companyName" label="公司名称" width="160">
        </el-table-column>
        <el-table-column prop="linkman" label="姓名"> </el-table-column>
        <el-table-column prop="--" label="财务"> </el-table-column>
        <el-table-column prop="employeeName" label="销售员"> </el-table-column>
        <el-table-column prop="--" label="采购"> </el-table-column>
        <el-table-column prop="--" label="邮箱"> </el-table-column>
        <el-table-column prop="companyName" label="关联公司"> </el-table-column>
        <el-table-column prop="phone" label="电话"> </el-table-column>
        <el-table-column prop="linkAddress" label="经营地址"> </el-table-column>
      </el-table>

      <!--<div class="title borderShadow">会员信息</div>
      <div class="main2 borderShadow">
        <el-form ref="form" :model="userInfo" label-width="120px">
          <el-form-item label="登录账户：" prop="customerName">
            {{ userInfo.customerName || "--" }}
          </el-form-item>
          <el-form-item label="客户名称：" prop="customerName">
            {{ userInfo.customerName || "--" }}
          </el-form-item>
          <el-form-item label="联系人：" prop="linkman">
            {{ userInfo.linkman || "--" }}
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            {{ userInfo.phone || "--" }}
          </el-form-item>
          <el-form-item label="销售员：" prop="employeeName">
            {{ userInfo.employeeName || "--" }}
          </el-form-item>
          <el-form-item label="关联公司：" prop="companyName">
            {{ userInfo.companyName || "--" }}
          </el-form-item>
          <el-form-item label="经营地址：" prop="linkAddress">
            {{ to_f(userInfo.linkAddress || "--") }}
          </el-form-item>
          <el-form-item label="余额：" prop="balance">
            {{ to_f(userInfo.balance || "0.00") }}
          </el-form-item>
        </el-form>
      </div>-->
    </div>
    <!-- 个人信息->个人信息 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
export default {
  data() {
    // 1.data
    return {
      userInfo: [], // 1.1.userInfo
      timer: null, // 1.2.定时器对象，用于查询用户信息直到查询到位置
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
  },

  mounted() {
    this.timer = setInterval(() => {
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        this.userInfo.push(JSON.parse(localStorage.userInfo));
      }
      console.log(this.userInfo);
    }, 20);
  },
};
</script>
